import axios from 'axios'
import config from '../config'

export default {

    getTagList() {
        if (null !== localStorage.getItem('globalTags')) {
            return new Promise((resolve) => {
                resolve(localStorage.getItem('globalTags').split(','));
            });
        }

        return axios.get(config.publicPath + 'global_macros', {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
            let data = response.data;
            localStorage.setItem('globalTags', data);

            return data;
        });
    }
}
